import { MultiValueRemoveProps, components } from 'react-select';

import { Icon, tv } from '@eluve/components';

export const hiddenIndicatorComponents = {
  DropdownIndicator: () => null,
  IndicatorSeparator: () => null,
  LoadingIndicator: () => null,
} as const;

export const MultiValueRemove = (props: MultiValueRemoveProps) => {
  return (
    <components.MultiValueRemove {...props}>
      <Icon className="size-3" name="X" />
    </components.MultiValueRemove>
  );
};

const styles = tv({
  slots: {
    container: 'w-full',
    control:
      'relative flex cursor-text! flex-wrap items-center justify-between rounded-xl border border-border-primary p-2 transition-all outline-none',
    valueContainer: 'relative flex-1 items-center gap-2 overflow-hidden p-0',
    menu: 'absolute top-full z-9999 mt-3 w-full rounded-2xl border border-border-primary bg-bg-primary p-0 shadow-xl',
    menuList: 'max-h-75 overflow-y-auto p-3',
    placeholder:
      'col-start-1 col-end-3 row-start-1 row-end-2 py-1 text-text-tertiary',
    noOptionsMessage: 'text-left text-text-tertiary',
    multiValue:
      'm-0 -mr-1 -ml-2 flex size-6 min-w-0 justify-end bg-transparent',
    multiValueRemove:
      '-my-1 flex size-8 items-center rounded-full border-8 border-transparent bg-text-tertiary bg-clip-padding p-0.5 text-bg-secondary hover:bg-text-secondary',
    option: 'rounded-lg p-3 select-none',
    loadingMessage: 'text-left',
    input:
      'col-start-1 col-end-3 row-start-1 inline-grid grid-cols-[0_min-content]',
  },
  variants: {
    disabled: {
      true: {
        control: 'bg-white',
      },
    },
    optionFocused: {
      true: {
        option: 'bg-border-primary',
      },
    },
    hasMultiValue: {
      true: {
        valueContainer: 'flex flex-wrap',
      },
      false: {
        valueContainer: 'grid',
      },
    },
  },
  defaultVariants: {
    hasMultiValue: false,
  },
});

export const searchableStyle = styles();
